import React, { useState, useEffect } from "react";
import Modal from "common/Modal.jsx";

const SubscriberGroupName = ({ name = "", onChange }) => {
  return (
    <div className="form-group margin-b-0">
      <label>Subscriber Group Name:</label>
      <div className="input-group margin-b-0">
        <span className="input-group-addon">
          <i className="material-icons">location_on</i>
        </span>
        <div className="form-line">
          <input
            type="text"
            name="name"
            className="form-control align-left"
            autoFocus
            onChange={({ target }) => onChange(target.value)}
            value={name}
          />
        </div>
      </div>
    </div>
  );
};

const CreateSubscriberGroupModal = ({
  open,
  onOk = doesNothing,
  onClose = doesNothing,
  groupNames
}) => {
  const [error, setError] = useState(null);
  const [name, setName] = useState("");

  if (open === false) {
    return null;
  }

  const submit = (name) => {
    onOk(name);
    onClose();
  };

  const handleChange = (name) => {
    setError(null);
    const subscriberGroupsSet = new Set([...groupNames]);
    if (name.length === 0) {
      setError("Invalid name: can't be empty");
    } else if (name.length > 63) {
      setError("Invalid name: can't exceed 63 characters");
    } else if (name.includes(" ")) {
      setError("Invalid name: can't contain whitespaces");
    } else if (subscriberGroupsSet.has(name)) {
      setError("This subscriber group already exist.");
    } else {
      setName(name);
    }
  };

  if (open === false) {
    return null;
  }
  return (
    <Modal
      title="Create subscriber group"
      superIcon="add_circle"
      content={() => (
        <SubscriberGroupName onChange={handleChange} name={name} />
      )}
      applyLabel="OK"
      onApply={()=>submit(name)}
      applyDisabled={error !== null}
      closeLabel="CANCEL"
      onClose={onClose}
      footerMessage={
        (error !== null && (
          <span className="modal-err-msg color-red align-left">{error}</span>
        )) ||
        null
      }
    />
  );
};

export default CreateSubscriberGroupModal;
